module.exports = __webpack_public_path__ + "img/sidebar-1.25942223.jpeg";